var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },

  {
    id: "comprehensive_contract_code",
    label: "包括契約コード",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_comprehensive_contract: "A"
    },
  },
  {
    id: "comprehensive_contract_name",
    label: "包括契約名",
    type: types.INPUT,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_comprehensive_contract: "B"
    },
  },
  {
    id: "maker_name",
    label: "メーカー名",
    type: types.SELECT_BOX4,
    api:"/master_maker/list_maker_name",
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_comprehensive_contract: "C"
    },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_master_comprehensive_contract.js